import IParamScriptsRule from "../database/IParamScriptsRule";

class SizeConfigurator {

    public rule: IParamScriptsRule;
    private target: HTMLElement;

    private xValue: number | null;
    private xUnit: HTMLSelectElement | undefined;

    private yValue: number | null;
    private yUnit: HTMLSelectElement | undefined;
    
    private zValue: number | null;
    private zUnit: HTMLSelectElement | undefined;

    private cloned: HTMLElement | null;

    private fallbackValue: number; // default value

    constructor(rule: IParamScriptsRule, setParameters: () => void) {

        // sanity check
        if(rule.parameterType !== "Size" && rule.parameterType !== "Size2D" && rule.parameterType !== "Size3D") {
            throw new Error("SizeConfigurator: unsupported parameter type: " + rule.parameterType);
        }

        this.rule = rule; // store rule for later use

        this.xValue = null;
        this.yValue = null;
        this.zValue = null;

        this.cloned = null;

        this.fallbackValue = 500;

        switch(this.rule.tab) {
            case "configuration": this.target = document.querySelector<HTMLElement>('div[data-id="configuration"]')!; break;
            case "material":
            case "materials": this.target = document.querySelector<HTMLElement>('div[data-id="material"]')!; break;
            default: this.target = document.querySelector<HTMLElement>('div[data-id="material"]')!; break;
        }

        // create the HTML UI
        const templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;
        const templateGroup: HTMLElement = templates.querySelector<HTMLElement>('[data-id="dimensions"]')!;
        const clonedGroup: HTMLElement = templateGroup.cloneNode(true) as HTMLElement;

        // assign displayName as title
        const displayNameHTML : HTMLElement = clonedGroup.querySelector<HTMLInputElement>('[data-id="display-name"]')!;
        displayNameHTML.innerHTML = this.rule.title;

        ////////////////////////////////////////////////////////////////////////////////////
        // select the correct HTML templete based on parameterType eg Size1D, Size2D, Size3D
        ////////////////////////////////////////////////////////////////////////////////////
        let template: HTMLElement | null = null;
        switch(this.rule.parameterType) {
            case "Size": {
                template = templates.querySelector<HTMLElement>('[data-id="Size1D"]')!;
                break;
            }
            case "Size2D": {
                template = templates.querySelector<HTMLElement>('[data-id="Size2D"]')!;
                break;
            }
            case "Size3D": {
                template = templates.querySelector<HTMLElement>('[data-id="Size3D"]')!;
                break;
            }
            default: throw new Error("Unsupported parameterType: " + this.rule.parameterType);
        }
        const cloned: HTMLElement = template!.cloneNode(true) as HTMLElement;

        ///////////////////////////////
        // input change event listeners
        ///////////////////////////////
        switch(this.rule.parameterType) {
            case "Size": {

                this.xUnit = cloned.querySelector<HTMLSelectElement>('[data-id="x-unit"]')!;
                [this.xValue, this.xUnit.value] = this.parseValue(this.rule.parameterValue as string);

                const xValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="width"]')!;
                xValueHTML.value = String(this.xValue);
                xValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.xValue = value;
                    xValueHTML.value = String(value);
        
                    this.rule.parameterValue = this.xValue + this.xUnit!.value;

                    console.log("X changed");
                    setParameters();
                });

                this.xUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("x unit changed: " + this.xUnit!.value);
                    setParameters();
                });

                break;
            }
            case "Size2D": {

                this.xUnit = cloned.querySelector<HTMLSelectElement>('[data-id="x-unit"]')!;
                this.yUnit = cloned.querySelector<HTMLSelectElement>('[data-id="y-unit"]')!;
                
                const [xTerm, yTerm] = (this.rule.parameterValue as string).split(',').map(item => item.trim());
                [this.xValue, this.xUnit.value] = this.parseValue(xTerm);
                [this.yValue, this.yUnit.value] = this.parseValue(yTerm);
                
                const xValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="width"]')!;
                xValueHTML.value = String(this.xValue);
                xValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.xValue = value;
                    xValueHTML.value = String(value);
        
                    this.rule.parameterValue = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value;

                    console.log("X changed");
                    setParameters();
                });

                this.xUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("x unit changed: " + this.xUnit!.value);
                    setParameters();
                });

                const yValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="height"]')!;
                yValueHTML.value = String(this.yValue);
                yValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.yValue = value;
                    yValueHTML.value = String(value);
                    
                    this.rule.parameterValue = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value;

                    console.log("Y changed");
                    setParameters();
                });

                this.yUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("y unit changed: " + this.yUnit!.value);
                    setParameters();
                });

                break;
            }

            case "Size3D": {
                this.xUnit = cloned.querySelector<HTMLSelectElement>('[data-id="x-unit"]')!;
                this.yUnit = cloned.querySelector<HTMLSelectElement>('[data-id="y-unit"]')!;
                this.zUnit = cloned.querySelector<HTMLSelectElement>('[data-id="z-unit"]')!;
                
                const [xTerm, yTerm, zTerm] = (this.rule.parameterValue as string).split(',').map(item => item.trim());
                [this.xValue, this.xUnit.value] = this.parseValue(xTerm);
                [this.yValue, this.yUnit.value] = this.parseValue(yTerm);
                [this.zValue, this.zUnit.value] =this. parseValue(zTerm);

                const xValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="width"]')!;
                xValueHTML.value = String(this.xValue);
                xValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.xValue = value;
                    xValueHTML.value = String(value);
        
                    this.rule.parameterValue = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value + ", " + this.zValue + this.zUnit!.value;

                    console.log("X changed");
                    setParameters();
                });

                this.xUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("x unit changed: " + this.xUnit!.value);
                    setParameters();
                });

                const yValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="height"]')!;
                yValueHTML.value = String(this.yValue);
                yValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.yValue = value;
                    yValueHTML.value = String(value);
                    
                    this.rule.parameterValue = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value + ", " + this.zValue + this.zUnit!.value;

                    console.log("Y changed");
                    setParameters();
                });

                this.yUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("y unit changed: " + this.yUnit!.value);
                    setParameters();
                });

                const zValueHTML: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="depth"]')!;
                zValueHTML.value = String(this.zValue);
                zValueHTML.addEventListener('change', (event) => {
                    const value = this.validateNumeric((event.target! as HTMLInputElement).value, this.fallbackValue);
                    this.zValue = value;
                    zValueHTML.value = String(value);
        
                    this.rule.parameterValue = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value + ", " + this.zValue + this.zUnit!.value;

                    console.log("Z changed");
                    setParameters();
                });

                this.zUnit.addEventListener("change", () => {
                    //this.updateUI(this.xUnit.value);
                    console.log("z unit changed: " + this.zUnit!.value);
                    setParameters();
                });

                break;
            }

        }
        
        clonedGroup.querySelector('[data-id="content"]')!.appendChild(cloned);

        this.target.appendChild(clonedGroup);

        this.cloned = cloned; // save for later use
    }

    private parseValue(str: string): [number, string] {
        const match: RegExpMatchArray | null = str.match(/^(\d+)(\D+)$/);
        if (match) {
            return [parseInt(match[1], 10), match[2].trim()]; // Return as [value, unit]
        }
        throw new Error("Invalid format");
    };

    private validateNumeric(v: string, fallback: number): number {
        if(v === "" || isNaN(Number(v))) {
            return fallback;
        }
        return Number(v);
    }

    public getDimensionsWithoutUnits(): string {
        let dims: string[] = [];
        if(this.xValue != null) {
            dims.push(String(this.xValue));
        }
        if(this.yValue != null) {
            dims.push(String(this.yValue));
        }
        if(this.zValue != null) {
            dims.push(String(this.zValue));
        }
        return dims.join("x");
    }

    public cleanup(): void {
        const templates: NodeListOf<HTMLElement> = this.target.querySelectorAll<HTMLElement>('[data-id="dimensions"]');
        for(let template of templates) {
            template.remove();
        }
    }

    // TODO: create paramscript interface type
    public createParamScript(): Object {
        const res: any = {};

        res[this.rule.parameterName] = {};

        // Cabinet Size3D eg width&height&depth, Board Size2D eg width&height, Front Size1D eg diameter/depth...
        res[this.rule.parameterName]["TargetType"] = this.rule.targetType;

        if(this.rule.targetPath != null) {
            res[this.rule.parameterName]["Path"] =  this.rule.targetPath;
        }

        switch(this.rule.parameterType) {
            case "Size": {
                res[this.rule.parameterName][this.rule.parameterProperty] = this.xValue + this.xUnit!.value;
                break;
            }
            case "Size2D": {
                res[this.rule.parameterName][this.rule.parameterProperty] = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value;
                break;
            }
            case "Size3D": {
                res[this.rule.parameterName][this.rule.parameterProperty] = this.xValue + this.xUnit!.value + ", " + this.yValue + this.yUnit!.value + ", " + this.zValue + this.zUnit!.value;
                break;
            }
        }

        return res;
    }

}

export default SizeConfigurator;
